// Dourado vocabulary expansion — TIME & WEATHER theme (net-new cards).
//
// Extends the `time-weather` blocks in ./vocabulary.js without reusing any
// headword already defined there. Seed upserts on `portuguese`, so every value is
// unique.
//   [ portuguese, english, emoji, part_of_speech, gender, example_pt, example_en ]

export const VOCAB_TIME_WEATHER = [
  {
    theme: "time-weather", tier: "A1", rows: [
      ["a semana", "week", "📅", "noun", "f", "A semana tem sete dias.", "The week has seven days."],
      ["o mês", "month", "🗓️", "noun", "m", "Julho é o meu mês preferido.", "July is my favourite month."],
      ["o ano", "year", "🎉", "noun", "m", "O ano começa em janeiro.", "The year starts in January."],
      ["a hora", "hour / time", "🕐", "noun", "f", "Que horas são?", "What time is it?"],
      ["a tarde", "afternoon / evening", "🌇", "noun", "f", "À tarde faz mais calor.", "It's hotter in the afternoon."],
      ["chover", "to rain", "🌧️", "verb", "", "Vai chover esta tarde.", "It's going to rain this afternoon."],
      ["nevar", "to snow", "🌨️", "verb", "", "Em janeiro costuma nevar.", "It usually snows in January."],
      ["o arco-íris", "rainbow", "🌈", "noun", "m", "Apareceu um arco-íris depois da chuva.", "A rainbow came out after the rain."],
      ["o guarda-chuva", "umbrella", "☂️", "noun", "m", "Leva o guarda-chuva, por via das dúvidas.", "Take the umbrella, just in case."],
      ["o calor", "heat", "🥵", "noun", "m", "Não suporto o calor de agosto.", "I can't stand the August heat."],
    ],
  },
  {
    theme: "time-weather", tier: "A2", rows: [
      ["o clima", "climate", "🌍", "noun", "m", "O clima do norte é mais ameno.", "The climate in the north is milder."],
      ["a previsão", "forecast", "📡", "noun", "f", "A previsão anuncia chuva.", "The forecast announces rain."],
      ["a brisa", "breeze", "🍃", "noun", "f", "Sopra uma brisa agradável.", "A pleasant breeze is blowing."],
      ["a geada", "frost", "❄️", "noun", "f", "Houve uma geada esta noite.", "There was a frost last night."],
      ["o trovão", "thunder", "🌩️", "noun", "m", "O trovão assustou o cão.", "The thunder scared the dog."],
      ["a poça", "puddle", "💧", "noun", "f", "A criança saltou para a poça.", "The child jumped in the puddle."],
      ["a sombra", "shade / shadow", "🌳", "noun", "f", "Comemos à sombra da árvore.", "We eat in the shade of the tree."],
      ["molhado", "wet", "💦", "adjective", "", "O chão está molhado.", "The floor is wet."],
      ["a primavera", "spring", "🌸", "noun", "f", "Na primavera tudo floresce.", "In spring everything blossoms."],
      ["o inverno", "winter", "⛄", "noun", "m", "O inverno aqui é muito frio.", "Winter here is very cold."],
    ],
  },
  {
    theme: "time-weather", tier: "B1", rows: [
      ["a frente", "weather front", "🌀", "noun", "f", "Uma frente fria chega amanhã.", "A cold front arrives tomorrow."],
      ["a onda de calor", "heatwave", "🔥", "phrase", "", "A onda de calor vai durar uma semana.", "The heatwave will last a week."],
      ["o aguaceiro", "downpour", "🌧️", "noun", "m", "Apanhámos um aguaceiro sem guarda-chuva.", "A downpour caught us without an umbrella."],
      ["a depressão", "storm system", "🌪️", "noun", "f", "A depressão traz vento e chuva.", "The storm system brings wind and rain."],
      ["o degelo", "thaw", "🫠", "noun", "m", "O degelo enche os rios em abril.", "The thaw fills the rivers in April."],
      ["o aquecimento global", "global warming", "🌡️", "phrase", "", "O aquecimento global muda as estações.", "Global warming is shifting the seasons."],
      ["abafado", "muggy / sultry", "😓", "adjective", "", "O dia está abafado e pegajoso.", "The day is muggy and sticky."],
      ["o orvalho", "dew", "🌫️", "noun", "m", "De manhã há orvalho na relva.", "In the morning there's dew on the grass."],
      ["a chuvada", "heavy shower", "⛈️", "noun", "f", "Caiu uma chuvada de dez minutos.", "A ten-minute heavy shower fell."],
      ["quente", "hot (of weather)", "☀️", "adjective", "", "Foi um verão muito quente.", "It was a very hot summer."],
    ],
  },
];
